<div *ngIf="!error" class="alert alert-success costum-class" role="alert">
    <strong>Cохранено!</strong>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div *ngIf="error" class="alert alert-danger costum-class" role="alert">
    <strong>Ошибка!</strong>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
